export function getCurrentSubSectionData(subSectionsData, subSection) {
  return subSectionsData?.find((data) => data?.subSectionCode === subSection?.code)
}

export function getSingleSubSectionDataHandler(setSubSectionsData, subSection) {
  return (prevDataOrUpdater) => {
    setSubSectionsData((prevList) => {
      const currentSubSectionData = getCurrentSubSectionData(prevList, subSection)
      let updatedData
      if (typeof prevDataOrUpdater === 'function') {
        updatedData = prevDataOrUpdater(currentSubSectionData)
      } else {
        updatedData = prevDataOrUpdater
      }
      const isExisting = prevList?.some((data) => data?.subSectionCode === subSection?.code)
      if (isExisting) {
        return prevList?.map((data) =>
          data?.subSectionCode === subSection?.code ? { ...data, ...updatedData } : data,
        )
      }
      return [...prevList, { ...updatedData, subSectionCode: subSection?.code }]
    })
  }
}
